import { render, staticRenderFns } from "./ClauseEditor.vue?vue&type=template&id=f4c48908&scoped=true"
import script from "./ClauseEditor.vue?vue&type=script&lang=ts"
export * from "./ClauseEditor.vue?vue&type=script&lang=ts"
import style0 from "./ClauseEditor.vue?vue&type=style&index=0&id=f4c48908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c48908",
  null
  
)

export default component.exports